import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
	selector: 'overlay',
	template: `
		<div class="overlay-wrapper" [attr.active]="isActive">
			<ng-content> </ng-content>
		</div>
	`,
	styleUrls: ['./overlay.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class OverlayComponent {
	@Input()
	isActive = false;
}
